import { useRef, useState } from "react";
import { BookText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const PlanComptableButton = ({ plan, onImported }) => {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);
  const envoyer = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setLoading(true);
    try { const { data } = await api.post("/plan-comptable/import", fd); onImported(data); toast.success(`${data.comptes.length} comptes importés`); }
    catch (e) { toast.error(errMsg(e)); } finally { setLoading(false); ref.current.value = ""; }
  };
  return (
    <div className="flex items-center gap-2">
      <input ref={ref} type="file" accept=".xlsx,.xls,.csv" className="hidden" onChange={(e) => envoyer(e.target.files[0])} data-testid="plan-comptable-file-input" />
      <Button variant="outline" onClick={() => ref.current.click()} disabled={loading} data-testid="plan-comptable-import-button">
        {loading ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <BookText className="h-4 w-4 mr-2" />}
        {plan.comptes.length ? "Remplacer le plan comptable" : "Importer le plan comptable"}
      </Button>
      {plan.comptes.length > 0 && <span className="text-xs text-slate-500" data-testid="plan-comptable-info">{plan.comptes.length} comptes · {plan.fichier}</span>}
    </div>
  );
};
